var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 181,
    viewBox: "0 0 222 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.92 176C157.407 176 196.717 136.677 196.717 88C196.717 39.3228 157.407 0 108.92 0C60.4318 0 21.1221 39.3228 21.1221 88C21.1221 136.677 60.4318 176 108.92 176Z",
    fill: "#F2EAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M206.761 51.7946C210.682 51.7946 213.861 48.6147 213.861 44.6922C213.861 40.7697 210.682 37.5898 206.761 37.5898C202.84 37.5898 199.661 40.7697 199.661 44.6922C199.661 48.6147 202.84 51.7946 206.761 51.7946Z",
    fill: "#F2EAF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.151 23.9059C219.829 23.9059 222 21.7343 222 19.0555C222 16.3767 219.829 14.2051 217.151 14.2051C214.473 14.2051 212.302 16.3767 212.302 19.0555C212.302 21.7343 214.473 23.9059 217.151 23.9059Z",
    fill: "#F2EAF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0609 56.818C17.7388 56.818 19.9097 54.6464 19.9097 51.9676C19.9097 49.2888 17.7388 47.1172 15.0609 47.1172C12.383 47.1172 10.2122 49.2888 10.2122 51.9676C10.2122 54.6464 12.383 56.818 15.0609 56.818Z",
    fill: "#F2EAF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0659 162.315C29.0392 162.315 33.0708 158.282 33.0708 153.307C33.0708 148.332 29.0392 144.299 24.0659 144.299C19.0927 144.299 15.061 148.332 15.061 153.307C15.061 158.282 19.0927 162.315 24.0659 162.315Z",
    fill: "#F2EAF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.31 52.8344H40.1708C36.8805 52.8344 34.283 50.236 34.283 46.9447V13.1652C34.283 9.87382 36.8805 7.27539 40.1708 7.27539H190.137C193.427 7.27539 196.024 9.87382 196.024 13.1652V46.9447C196.198 50.236 193.427 52.8344 190.31 52.8344Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6487 29.9687C70.6487 33.7797 68.917 37.2443 66.3194 39.6695C64.0682 41.7482 60.9511 42.9608 57.6609 42.9608C54.3707 42.9608 51.2536 41.7482 49.0024 39.6695C46.2316 37.2443 44.6731 33.7797 44.6731 29.9687C44.6731 22.8663 50.5609 16.9766 57.6609 16.9766C64.7609 16.9766 70.6487 22.8663 70.6487 29.9687Z",
    fill: "#DFD6EE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M113.249 26.1571H79.9999C79.134 26.1571 78.6145 25.4641 78.6145 24.7712V20.4405C78.6145 19.5744 79.3072 19.0547 79.9999 19.0547H113.249C114.114 19.0547 114.634 19.7476 114.634 20.4405V24.7712C114.634 25.6374 114.114 26.1571 113.249 26.1571Z",
    fill: "#DFD6EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.732 40.8817H79.9999C79.134 40.8817 78.6145 40.1887 78.6145 39.4958V35.1651C78.6145 34.299 79.3072 33.7793 79.9999 33.7793H152.732C153.597 33.7793 154.117 34.4722 154.117 35.1651V39.4958C154.117 40.362 153.424 40.8817 152.732 40.8817Z",
    fill: "#DFD6EE"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.31 166.473H40.1708C36.8805 166.473 34.283 163.875 34.283 160.583V126.804C34.283 123.512 36.8805 120.914 40.1708 120.914H190.137C193.427 120.914 196.024 123.512 196.024 126.804V160.583C196.198 163.875 193.427 166.473 190.31 166.473Z",
    fill: "white"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6487 143.607C70.6487 147.418 68.917 150.883 66.3194 153.308C64.0682 155.387 60.9511 156.599 57.6609 156.599C54.3707 156.599 51.2536 155.387 49.0024 153.308C46.2316 150.883 44.6731 147.418 44.6731 143.607C44.6731 136.505 50.5609 130.615 57.6609 130.615C64.7609 130.615 70.6487 136.505 70.6487 143.607Z",
    fill: "#DFD6EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.249 139.97H79.9999C79.134 139.97 78.6145 139.277 78.6145 138.584V134.253C78.6145 133.387 79.3072 132.867 79.9999 132.867H113.249C114.114 132.867 114.634 133.56 114.634 134.253V138.584C114.634 139.277 114.114 139.97 113.249 139.97Z",
    fill: "#DFD6EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.732 154.694H79.9999C79.134 154.694 78.6145 154.001 78.6145 153.308V148.978C78.6145 148.111 79.3072 147.592 79.9999 147.592H152.732C153.597 147.592 154.117 148.285 154.117 148.978V153.308C154.117 154.001 153.424 154.694 152.732 154.694Z",
    fill: "#DFD6EE"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.854 109.653H14.8878C11.5976 109.653 9 107.054 9 103.763V69.9835C9 66.6922 11.5976 64.0938 14.8878 64.0938H164.854C168.144 64.0938 170.741 66.6922 170.741 69.9835V103.763C170.915 107.054 168.144 109.653 164.854 109.653Z",
    fill: "white"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9657 82.9754H54.7169C53.8511 82.9754 53.3315 82.2825 53.3315 81.5896V77.2589C53.3315 76.3927 54.0242 75.873 54.7169 75.873H87.9657C88.8315 75.873 89.351 76.566 89.351 77.2589V81.5896C89.351 82.4557 88.8315 82.9754 87.9657 82.9754Z",
    fill: "#DFD6EE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M127.449 97.8738H54.7169C53.8511 97.8738 53.3315 97.1809 53.3315 96.488V92.1573C53.3315 91.2912 54.0242 90.7715 54.7169 90.7715H127.275C128.141 90.7715 128.661 91.4644 128.661 92.1573V96.488C128.834 97.1809 128.141 97.8738 127.449 97.8738Z",
    fill: "#DFD6EE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5389 86.787C45.5389 90.4248 43.9804 93.7162 41.556 96.1414C41.3828 96.3146 41.3828 96.3146 41.2096 96.4878C38.9584 98.5666 35.8414 99.7792 32.5511 99.7792C29.2609 99.7792 26.317 98.5666 24.0657 96.6611C24.0657 96.6611 24.0657 96.6611 23.8926 96.6611C21.1218 94.2359 19.3901 90.7713 19.3901 86.787C19.3901 79.6847 25.2779 73.7949 32.3779 73.7949C39.6511 73.7949 45.5389 79.6847 45.5389 86.787Z",
    fill: "#DFD6EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9146 89.3848C29.0877 89.5579 29.2609 89.7311 29.4341 89.9043C29.2609 89.7311 29.0877 89.5579 28.9146 89.3848Z",
    fill: "#3973F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 25.283,
    y: 3.27539,
    width: 179.749,
    height: 63.5591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 25.283,
    y: 116.914,
    width: 179.749,
    height: 63.559,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0,
    y: 60.0938,
    width: 179.749,
    height: 63.5591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e0d4ff58db053ff5a61a03f6f4a671da.svg";
export { ForwardRef as ReactComponent };